import { render, staticRenderFns } from "./SanitizeClient.vue?vue&type=template&id=b8119f1c&scoped=true&"
import script from "./SanitizeClient.vue?vue&type=script&lang=js&"
export * from "./SanitizeClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8119f1c",
  null
  
)

export default component.exports